define('TescoMobile_ClubCard/js/catalog-add-to-cart-mixin',['ko', 'jquery', 'TescoMobile_ClubCard/js/view/clubcard-selection-modal', 'uiRegistry'], function (ko, $, confirmModal, registry) {
  'use strict';

  const mixin = {
    clubCardPriceSelectionConfirmed: false,
    _ajaxSubmitAction: function (form) {
      const self = this;
      const clubcardProvider = registry.get('tm-clubcard-price-provider');
      if (!clubcardProvider) {
        return this._super(form);
      }
      if (form) {
        clubcardProvider.bindForm(form);
      }
      const hasLinkedClubCard = clubcardProvider.hasLinkedClubCard();
      if (hasLinkedClubCard && clubcardProvider.clubCardPrice()) {
        clubcardProvider.getClubCardPriceFlagElement().val(Number(hasLinkedClubCard));
      }
      if (!clubcardProvider.clubCardPrice() || hasLinkedClubCard || this.clubCardPriceSelectionConfirmed) {
        return this._super(form);
      }
      confirmModal({
        actions: {
          cancel: function () {
            self.clubCardPriceSelectionConfirmed = false;
            self.enableAddToCartButton(form);
          },
          confirm: function () {
            self.clubCardPriceSelectionConfirmed = true;
            self._ajaxSubmitAction(form);
          }
        }
      });
    }
  };
  return function (widget) {
    $.widget('mage.catalogAddToCart', widget, mixin);
    return $.mage.catalogAddToCart;
  };
});

